import { FeatureModel } from '../../Models/feature-model';
import { Utilities } from 'src/app/utilities';

export class FeatureMock {

  private static models: FeatureModel[];
  private static  idCounter = 0;

  public static initMocks(){
    FeatureMock.models = [];
    let feature1 = new FeatureModel();
    feature1.id = "1wefefcefefref";
    feature1.name = "A test feature";
    feature1.fId = ++this.idCounter;
    feature1.scenario = ["rettsbxyyn","fwgnbwghwbhwgkgw","rettsbxyyn"];
    feature1._type = "feature";

    FeatureMock.models.push(feature1);
    FeatureMock.models.push({fId:++this.idCounter, id: "wdyuwyuwdwj" , name: "One more feature" , scenario: [ "rettsbxyyn" ], _type:"feature"});
  }

  public static findByObjectId(id: string):FeatureModel{
    let m = FeatureMock.models;
    for(let i = 0; i< m.length; i++){
      if(id == m[i].id) return m[i];
    }
    return null;
  }

  public static findById(id:number):FeatureModel{
    let m = FeatureMock.models;
    for(let i = 0; i< m.length; i++){
      if(id == m[i].fId) return m[i];
    }
    return null;
  }

  public static getItems():FeatureModel[]{
    return FeatureMock.models;
  }

  public static addNewFeature(model: FeatureModel) {
    model.id = Utilities.makeid(10);
    model.fId = ++this.idCounter;
    FeatureMock.models.push(model);
  }

  public static deleteModel(model: FeatureModel){
    let m = FeatureMock.models;
    for(let i = 0; i< m.length; i++){
      if(model.id == m[i].id) {
        FeatureMock.models.splice(i,1);
      }

    }
  }


}
